"use client";

import { Button, type ButtonProps, cn, useNotifications } from "@tosize/ui";

interface TargetButtonProps {
	target: string;
	copyTitle: string;
	copySubtitle?: string;
}

export function TargetButton(props: TargetButtonProps & ButtonProps) {
	const { target, copyTitle, copySubtitle, className, children, onClick, ...restProps } = props;
	const { notify } = useNotifications();

	return (
		<Button
			id={target}
			onClick={async (e) => {
				onClick?.(e);

				await window.navigator.clipboard.writeText(
					`${window.location.origin + window.location.pathname}#${target}`,
				);

				notify({ variant: "info", title: copyTitle, subtitle: copySubtitle });
			}}
			className={cn(className, "target")}
			{...restProps}
		>
			{children}
		</Button>
	);
}
